<script setup>
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'
import { ref, computed } from 'vue'
import { TagIcon, FireIcon, ArrowRightIcon } from '@heroicons/vue/24/outline'

const restoStore = useRestoGLobalStore()
const activeCategory = ref(null)

// Set active category
const setActiveCategory = (categoryId) => {
  activeCategory.value = categoryId
}

// Smooth scroll to category - centered in viewport
const scrollToCategory = (categoryId) => {
  setActiveCategory(categoryId)
  const element = document.getElementById(`category-id-${categoryId}`);
  if (element) {
    const yOffset = -80;
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

const handleGiftVoucherCategory = (category) => {
  let categoryName = category.category_name.toLowerCase()
  if (categoryName === 'gift voucher' || categoryName === 'gift vouchers') {
    return true
  }
  return false
}
</script>

<template>
  <div class="categories-list overflow-hidden transition-all duration-300">
    <h3 class="text-lg font-bold mb-4 text-gray-900 dark:text-white border-b pb-2 border-gray-200 dark:border-gray-700">Categories</h3>
    <ul role="list" class="space-y-2">
      <li v-for="(category, index) in restoStore.MENU_DATA?.categories" :key="category.category_id">
        <template v-if="!handleGiftVoucherCategory(category)"> 
          <span
            :data-id="category.category_id"
            :class="[
              category.current || activeCategory === category.category_id
                ? 'bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 border-l-4 border-indigo-600 dark:border-indigo-400'
                : 'text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 border-l-4 border-gray-200 dark:border-gray-700',
              'group flex justify-between items-center rounded-md p-2 pl-3 text-sm font-medium transition-all duration-200 cursor-pointer'
            ]"
            @click="scrollToCategory(category.category_id)"
          >
            <span>{{ category.category_name }}</span>
            <ArrowRightIcon class="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200" :class="category.current || activeCategory === category.category_id ? 'text-indigo-600 dark:text-indigo-400 opacity-100' : 'text-gray-400 dark:text-gray-500'" />
          </span>
        </template>
      </li>
    </ul>
  </div>
</template>

<style>
.categories-list {
  transform: translateZ(0); /* Hardware acceleration */
}

.categories-list ul li a {
  position: relative;
  overflow: hidden;
}

.categories-list ul li a:before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 0;
  background-color: rgba(99, 102, 241, 0.04);  /* Indigo with low opacity for light mode */
  transition: width 0.3s ease;
  z-index: -1;
}

.categories-list ul li a:hover:before {
  width: 100%;
}

/* Dark mode specific styles */
:root.dark .categories-list {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
}

:root.dark .categories-list ul li a:before {
  background-color: rgba(99, 102, 241, 0.08); /* Slightly higher opacity for dark mode */
}

:root.dark .categories-list ul li a:hover {
  background-color: rgba(79, 70, 229, 0.1); /* Improved hover color for dark mode */
}

:root.dark .categories-list ul li a.active {
  background-color: rgba(79, 70, 229, 0.15); /* Improved active color for dark mode */
}
</style>
